import PropTypes from "prop-types";
import { SideBarHeading } from "components";

const SideBarHeadingAdapter = ({ blok: { text, icon } }) => <SideBarHeading text={text} icon={icon} />;

export default SideBarHeadingAdapter;

SideBarHeadingAdapter.propTypes = {
  blok: PropTypes.shape({ text: PropTypes.string, icon: PropTypes.string }).isRequired,
};
